export class TooltipsService {
  static tooltipTester = (e) => {
    const element = e.target;
    if (!(element.clientWidth < element.scrollWidth)) {
      e.cancel = true;
    }
  };
}
